import React, { Component } from "react";
import { Button, DatePicker, Input, Popover, Select } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { getLuckyNumbersEventResultRequest , loadUpcomingDraws , getDrawsCategoriesAndTournaments} from "../../../redux/actions/sportTypesActions";

const Option = Select.Option;

const resultButtons = ["By Date", "By Game", "By Draw ID"];
export class HomeHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAction: "By Date",
      drawId:undefined
    };
    this.timeoutId = null;
  }
  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (!prevProps.connected && this.props.connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
        },
      };
      this.props.getDrawsCategoriesAndTournaments(request);
    }
  }
  componentDidMount() {
    const { getDrawsCategoriesAndTournaments, match, connected } = this.props;
    if (connected) {
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
        },
      };
      getDrawsCategoriesAndTournaments(request);
    }
  }

  resultDateFilter = (date, dateString) => {
    const {
      connected,
      match,
      getLuckyNumbersEventResultRequest,
      updateFormattedDate,
    } = this.props;
    let formattedDate = null;

    if (date) {
      formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
    }

    if (connected && formattedDate) {
      updateFormattedDate(formattedDate);
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
          dateOfMatch: formattedDate,
        },
      };
      getLuckyNumbersEventResultRequest(request, false);
    } else if (connected && !formattedDate) {
      updateFormattedDate(undefined);

      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
        },
      };
      getLuckyNumbersEventResultRequest(request, false);
    }
  };
  nextDrawsDateFilter = (date, dateString) => {
    const {
      connected,
      match,
      loadUpcomingDraws,
      updateFormattedDate,
    } = this.props;
    let formattedDate = null;

    if (date) {
      formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
    }


    if (connected && formattedDate) {
      updateFormattedDate(formattedDate);
      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
          dateOfMatch: formattedDate,
        },
      };
      loadUpcomingDraws(request, false);
    } else if (connected && !formattedDate) {
      updateFormattedDate(undefined);

      let request = {
        Data: {
          Feed: { FeedId: Number(match.params.feed) },
          Sport: { SportId: Number(match.params.sport) },
          pageSize: 8,
          pageIndex: 0,
        },
      };
      loadUpcomingDraws(request, false);
    }
  };
  updateFilter = (value) => {
    this.setState({
      selectedAction: value,
    });
  };
  selectGame = (id) => {
    console.log("id==",id);
    const { match, connected , getLuckyNumbersEventResultRequest } = this.props;
    if (connected) {
      this.props.updateGameId(Number(id))
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: 0,
            tournamentId: Number(id)
          },
        };
        getLuckyNumbersEventResultRequest(request, false);
    }
  };
  debounce = (func, delay) => {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      func();
    }, delay);
  };

  filterDrawId = () => {
    // Place your specific logic here
    const { getLuckyNumbersEventResultRequest, match, connected } = this.props;
    if (connected) {
      if(this.state.drawId){
        this.props.updateDrawId(Number(this.state.drawId))
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: 0,
            eventId: Number(this.state.drawId)
          },
        };
        getLuckyNumbersEventResultRequest(request, false);
      }else{
        this.props.updateDrawId(undefined)
        let request = {
          Data: {
            Feed: { FeedId: Number(match.params.feed) },
            Sport: { SportId: Number(match.params.sport) },
            pageSize: 8,
            pageIndex: 0,
          },
        };
        getLuckyNumbersEventResultRequest(request, false);
      }

    }
  };

  handleInputChange = (e) => {
    const { value } = e.target;
    this.setState({ drawId: value });
    this.debounce(this.filterDrawId, 1000);
  };
  disabledResultDate = (current) => {
    // Disable dates after today
    return current && current > moment().endOf('day');
  };
  disabledNextDrawDate = (current) => {
    // Disable dates before today
    return current && current < moment().startOf('day');
  };


  render() {
    const {
      luckyNumberUpcomintDraws,
      fromResults,
      fromNextDraws,
      drawsCategories,
      luckyNumberResultsPageTexts,
      luckyNumberUpcomingDrawsPageTexts,
      signedIn
    } = this.props;
    return (
      <div className="heading-title-and-buttons">
        <h2>{fromResults ?( luckyNumberResultsPageTexts && luckyNumberResultsPageTexts[0] && luckyNumberResultsPageTexts[0].title ): (luckyNumberUpcomingDrawsPageTexts && luckyNumberUpcomingDrawsPageTexts[0] && luckyNumberUpcomingDrawsPageTexts[0].title)} </h2>
        <div className={`header-button-container ${fromResults && `direction-column`}`}>
          

         
          {!fromNextDraws ? (
            fromResults ? (
              <>
              <div className="buttons-wrapper">
                {resultButtons.map((item, idx) => {
                  return (
                    <Button
                      key={idx}
                      className={`${this.state.selectedAction == item &&
                        `selected-button`}`}
                      onClick={() => this.updateFilter(item)}
                    >
                      {item}
                    </Button>
                  );
                })}
                 </div>
                {this.state.selectedAction == "By Date" ? (
                  <DatePicker
                    onChange={this.resultDateFilter}
                    style={{ width: "100%" }}
                    size="large"
                    placeholder={moment().format("dddd, D MMMM YYYY")}
                    showTime
                    format={["DD/MM/YYYY", "D/M/YYYY", "dddd, D MMMM YYYY"]}
                    disabledDate={this.disabledResultDate}

                  />
                ) : this.state.selectedAction == "By Game" ? (
                  <Select
                    showSearch={true}
                    optionFilterProp="children"
                    placement="bottom"
                    className="loyality-rewards-select"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    onSelect={this.selectGame}
                    defaultValue={
                      <div className="select-default-value">
                        <span>Select Game</span>
                      </div>
                    }
                  >
                    {drawsCategories &&
                      drawsCategories.drawGames &&
                      drawsCategories.drawGames.map((item) => {
                        return (
                          <Option value={item.gameId} key={item.gameId}>
                            {item.gameName}
                          </Option>
                        );
                      })}
                  </Select>
                ) : (
                  <Input className="dark-input" type="number" placeholder="Enter Draw ID" onChange={this.handleInputChange} />
                )}
              </>
            ) : (
              luckyNumberUpcomintDraws &&
              luckyNumberUpcomintDraws.map((item, idx) => {
                 return (item.upcomintDrawId == 3 && !this.props.signedIn) ? (
                  <Popover
                  overlayClassName="popup-slots"
                  placement="bottom"
                  arrowPointAtCenter
                  content={<p> Please Sign in or Register </p>}
                  trigger="click"
                >
                  <Button
                    key={idx}
                    // onClick={() =>
                    //   this.props.onChangeFilter(item.upcomintDrawId)
                    // }
                    className={`${this.props.currentFilter ==
                      item.upcomintDrawId && `selected-button`}`}
                  >
                    {item.upcomintDrawName}
                  </Button>
                  </Popover>
                ):(
                  <Button
                  key={idx}
                  onClick={() =>
                    this.props.onChangeFilter(item.upcomintDrawId)
                  }
                  className={`${this.props.currentFilter ==
                    item.upcomintDrawId && `selected-button`}`}
                >
                  {item.upcomintDrawName}
                </Button>
                );
              })
            )
          ) : (
            <DatePicker
              onChange={this.nextDrawsDateFilter}
              style={{ width: "100%" }}
              size="large"
              placeholder={moment().format("dddd, D MMMM YYYY")}
              showTime
              format={["DD/MM/YYYY", "D/M/YYYY", "dddd, D MMMM YYYY"]}
              disabledDate={this.disabledNextDrawDate}

            />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    luckyNumberUpcomintDraws: state.general.luckyNumberUpcomintDraws,
    connected: state.signalr.luckyNumbersConnected,
    drawsCategories: state.sportTypes.drawsCategories,
    luckyNumberResultsPageTexts: state.general.luckyNumberResultsPageTexts,
    luckyNumberUpcomingDrawsPageTexts: state.general.luckyNumberUpcomingDrawsPageTexts,
    signedIn: state.auth.signedIn,


  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLuckyNumbersEventResultRequest: (item, addToEvents) => {
      dispatch(getLuckyNumbersEventResultRequest(item, addToEvents));
    },
    getDrawsCategoriesAndTournaments: (item) => {
      dispatch(getDrawsCategoriesAndTournaments(item));
    },
    loadUpcomingDraws: (item , addNewList) => {
      dispatch(loadUpcomingDraws(item , addNewList));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader);
